module.exports = __webpack_public_path__ + "static/img/paypal-4.c589c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-4.png
// module id = mh/i
// module chunks = 1